import formApi from "../../services/api/FormApi";
import defaultApi from "../../services/api/DefaultApi";

const actions = {
  async login({ commit }, data) {
    let err, response;
    try {
      [err, response] = await formApi.login(data);
      if (!err) {
        commit("SET_TOKEN", response.data.data.access_token);
        commit("SET_USER", JSON.stringify(response.data.data.user));
        return response;
      } else {
        return err.response.data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async logout() {
    let err, response;
    try {
      [err, response] = await formApi.logout();
      if (!err) {
        return response;
      } else {
        return err.response.data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async cloneFormById({ commit }, id) {
    let err, response;
    try {
      [err, response] = await formApi.cloneFormById(id);

      if (!err) {
        commit("SET_CLONED_FORM", response);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getAllForm({ commit }) {
    let err, response;
    try {
      [err, response] = await formApi.getAllForm();

      if (!err) {
        commit("SET_FORMS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getMultipleForms({ commit }, ids) {
    let err, response;
    try {
      [err, response] = await formApi.getMultipleForms(ids);
      if (!err) {
        commit("SET_MULTIPLE_FORMS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async searchFormByName({ commit }, data) {
    let err, response;
    try {
      [err, response] = await formApi.searchFormByName(data);
      if (!err) {
        commit("SET_FORMS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async getAllSubmit({ commit }) {
    let err, response;
    try {
      [err, response] = await formApi.getAllSubmit();

      if (!err) {
        commit("SET_SUBMITS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getFormById({ commit }, data) {
    let err, response;
    try {
      if (data.id !== "0") {
        [err, response] = await formApi.getFormById(data);
        if (!data.isSubmitted) {
          commit("CLEAR_SUBMIT_DATA");
        }
        commit("CLEAR_FORM");
        commit("RESET_OVERVIEW");
        commit("SET_POSTCODE", null);
        if (!err) {
          commit("SET_FORM", response);
          return response;
        } else {
          return { ...err }.response;
        }
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getFormData({ commit }, data) {
    let err, response;
    try {
      commit("CLEAR_SUBMIT_DATA");
      if (data.id !== "0") {
        [err, response] = await formApi.getFormData(data);
        if (!err) {
          commit("SET_FORMDATA", response.data.submission);
          return response.data.form.id;
        }
      }
    } catch (e) {
      console.log(e);
    }
  },

  deleteFormById({ commit }, id) {
    return formApi
      .deleteFormById(id)
      .then(response => commit("DELETE_FORM", response));
  },
  saveAndDraft({ commit }, data) {
    return formApi
      .addForm(data)
      .then(response => commit("SET_DRAFTID", response));
  },

  async getClients({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.getClients(data);
      if (!err) {
        commit("SET_CLIENTS", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async checkPostCode({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkPostCode(data);
      if (!err) {
        commit("SET_POSTCODE", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async checkDisciplineCode({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkDisciplineCode(data);
      if (!err) {
        commit("SET_DISCIPLINECODE", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async checkZiggo({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkZiggo(data);
      if (!err) {
        commit("SET_ZIGGO", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async checkYoufone({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkYoufone(data);
      if (!err) {
        commit("SET_YOUFONE", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async checkKpn({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkKpn(data);
      if (!err) {
        commit("SET_KPN", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async checkTmobile({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.checkTmobile(data);
      if (!err) {
        commit("SET_TMOBILE", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getRates({ commit }, data) {
    commit("RATES_LOADER", true);
    let err, response;
    try {
      [err, response] = await defaultApi.getRates(data);
      if (!err) {
        commit("SET_RATES", response.data.data);
        commit("RATES_LOADER", false);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getNationality({ commit }, language) {
    let err, response;
    try {
      [err, response] = await defaultApi.getCountryList(language);
      if (!err) {
        commit("SET_NATIONALITY", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getConsumptionList({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.getConsumptionList(data);
      if (!err) {
        commit("SET_CONSUMPTION_LIST", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getMortgage({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.getMortgage(data);
      if (!err) {
        commit("SET_MORTGAGE", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async updateColumn({ commit },formdata) {
    let err, response;
    try {
      [err, response] = await defaultApi.updateColumn(formdata);
      if (!err) {
        commit("SET_COLUMN", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async getSolarList({ commit }, data) {
    let err, response;
    try {
      [err, response] = await defaultApi.getSolarList(data);
      if (!err) {
        commit("SET_SOLAR_LIST", response.data.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  resetData({ commit }) {
    commit("RESET_OVERVIEW");
  }
};

export default actions;
